export default __webpack_public_path__ + "static/media/myracleLogo.516c6822.webp";